var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_6827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 4.23077C1 10.1783 5.82174 15 11.7692 15H13.3846C13.813 15 14.2239 14.8298 14.5269 14.5269C14.8298 14.2239 15 13.813 15 13.3846V12.3996C15 12.0291 14.748 11.7061 14.3883 11.6163L11.2128 10.8223C10.8969 10.7433 10.5652 10.8617 10.3707 11.1216L9.67426 12.0499C9.47179 12.3199 9.12215 12.4391 8.80554 12.3228C7.63017 11.8907 6.56278 11.2082 5.67728 10.3227C4.79178 9.43722 4.10935 8.36983 3.67723 7.19446C3.56092 6.87785 3.6801 6.52821 3.95005 6.32574L4.87836 5.62933C5.13897 5.43477 5.25672 5.10236 5.17774 4.78718L4.38369 1.61169C4.34 1.43701 4.23918 1.28194 4.09727 1.17111C3.95535 1.06029 3.78047 1.00006 3.60041 1H2.61538C2.18696 1 1.77608 1.17019 1.47314 1.47314C1.17019 1.77608 1 2.18696 1 2.61538V4.23077Z",
    stroke: "#DB4B41",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_6827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.aa6354ebdea628eb5680c43c8fb3a5ec.svg";
export { ForwardRef as ReactComponent };